module.exports = __webpack_public_path__ + "img/mockup_drive@2x.a87ce4c1.png";